import { createAction, props } from '@ngrx/store';

import { BrokerListActionTypes } from './actions.model';

export const init = createAction(BrokerListActionTypes.Init);

export const filterChanged = createAction(
  BrokerListActionTypes.FilterChanged,
  props<{ filter: Record<string, any> }>()
);

export const listViewTypeChanged = createAction(
  BrokerListActionTypes.ListViewTypeChanged,
  props<{ viewType: string }>()
);

export const viewMoreClicked = createAction(
  BrokerListActionTypes.ViewMoreClicked
);
